<div class="row">
    <button mat-button mat-dialog-close="cancel" style="float: right !important;" class="circle_button shawarmer">X</button>
</div>
<div class="content" *ngIf="type=='share'">
    <div style="display: flex; justify-content: center; font-family: FrutigerLTArabic-65Bold; align-items: center; flex-grow: 1;">
        <h1>نشر البطولة</h1>
    </div>
    <div class="share-container">
        <div class="go_button facebook sm square">
            <i class="icon-facebook" (click)="shareEvent('facebook')">النشر عن طريق فيسبوك</i>
        </div>
        <div class="go_button twitter sm square">
            <i class="icon-twitter" (click)="shareEvent('twitter')">النشر عن طريق تويتر</i>
        </div>
        <div class="go_button whatsapp sm square">
            <i class="icon-whatsapp" (click)="shareEvent('whatsapp')">النشر عن طريق واتس اب</i>
        </div>
    </div>
</div>

<div class="content" style="padding:10px 20px;" *ngIf="type=='rules'">
    <h1 style="direction: rtl; width:100%;">القوانين والشروط العامة</h1>

    <perfect-scrollbar style="direction: rtl; padding:10px 10px 50px 10px; text-align: justify; line-height: 1.5;">
        <li> المشاركة في البطولة متاحة لجميع المواطنين و المقيمين في المملكة العربية السعودية</li>

        <li>المشاركة متاحة فقط لفئة الأعمار 13 سنة فما فوق.</li>

        <li>يجب على المشاركين التسجيل مسبقا عبر الصفحة المخصصة للبطولة على شبكة الإنترنت أثناء الفترة المحددة للتسجيل لكل مدينة.</li>

        <li>مسؤولية كل فرد التأكد من صحة معلوماته، و يحق للمنظمين استبعاد أي لاعب يكتشف أنه قام  بتسجيل معلومات خاطئة أو مضللة.        </li>

        <li>يسمح لكل لاعب التسجيل في بطولة واحدة فقط وفي مدينة واحدة، و يتم التأكد من هوية المشارك في مكان إقامة البطولة. و في حال تم اكتشاف مشاركة أحد اللاعبين في أكثر من مدينة واحدة سيتم إقصاؤه من البطولة.</li>

        <li> في حال تأهل أحد اللاعبين عبر تصفيات مدينة معينة، فإن فريق التنظيم سيتكفل بسفر و إقامة هذا اللاعب لنهائي الرياض. السفر سيكون من مدينة التصفيات التي تأهل عبرها، و لا يمكن للاعب تغيير المدينة التي سيسافر منها نهائيا.</li>

        <li>تسليم جوائز الفروع و مدن التصفيات سيكون في الفرع مباشرة بعد إنتهاء المباريات.</li>

        <li>تسليم جوائز البطولة الكبرى و نهائي المملكة سيكون خلال 7 أيام عمل.</li>

        <li> يمنع اصطحاب المتبارين أو إسداء النصائح و التوجيهات لهم أثناء مبارياتهم، وسيسمح فقط للاعب المشارك بالدخول للفرع في المنطقة المخصصة للبطولة.</li>

        <li>أي لاعب لا يقوم بالتحضير في الوقت المحدد أو يتخلف عن موعد إحدى مبارياته يعتبر منسحبا بشكل مباشر و يعتبر خاسرا لمباراته.</li>

        <li> سيطلب من المشتركين مغادرة المطعم عند انتهاء دورهم و ذلك للحفاظ على تنظيم المكان و منع الازدحام.</li>

        <li>على الجميع الإلتزام بالأخلاق الإسلامية و الروح الرياضية، و التقيد بتعليمات البطولة و توجيهات المنظمين، و في حال عدم الإلتزام لذلك فيعرض اللاعب نفسه للإقصاء من البطولة.</li>

        <h2 style="font-size:14px; direction: rtl; font-family: 'FrutigerLTArabic-65Bold'; font-weight: bold;">قوانين اللعب العامة:</h2>

        <li>جميع المباريات تلعب على الإعدادات الإفتراضية ما لم يتم ذكر عكس ذلك.</li>

        <li>إعدادات الماكرو المتوفرة عبر إعدادات اللعبة الداخلية ليد التحكم ستكون مسموحة.</li>

        <li> يمنع إستخدام التعديلات الخارجية على يد التحكم.</li>

        <li>إيقاف المباراة في أي وقت بالخطأ سيتسبب في خسارة المتسبب به للجولة.</li>

        <li>يمكنك استخدام يد التحكم الخاصة بك.</li>

        <li>جميع الأدوات التي يحضرها اللاعب معه هي مسؤوليته الخاصة.</li>

    </perfect-scrollbar>
</div>

<div class="content" style="direction: rtl; text-align: right; justify-content: flex-start;" *ngIf="type=='contact'">
    <h1 style="text-align: right;">تواصل معنا</h1>
    <p style="text-align: right;"><i class="icon-phone"></i> 920008080</p>

    <p style="text-align: right;"><i class="icon-twitter"></i>https://twitter.com/ShawarmerSA</p>
</div>

<div class="content" style="background:#604084;" *ngIf="type=='share-friend-zone'">
    <div style="display: flex; justify-content: center; font-family: 'proxima-nova-bold-webfont'; flex-flow:column; align-items: center; flex-grow: 1;">
        <i class="icon-share" style="font-size:30px"></i>
        <h1 style="font-size:20px; text-transform: uppercase; text-align: center;"> Get More People to the Friend Zone</h1>
    </div>
    <div class="share-container">
        <div class="go_button facebook sm square">
            <i class="icon-facebook" (click)="shareFriendZone('facebook')">Facebook</i>
        </div>
        <div class="go_button twitter sm square">
            <i class="icon-twitter" (click)="shareFriendZone('twitter')">Twitter</i>
        </div>
        <div class="go_button whatsapp sm square">
            <i class="icon-whatsapp" (click)="shareFriendZone('whatsapp')">Whatsapp</i>
        </div>
    </div>
</div>

<div class="content yalla-awc" *ngIf="type=='shareYallaAWC'">
  <div style="display: flex; justify-content: center; font-family: FrutigerLTArabic-65Bold; align-items: center; flex-grow: 1;">
    <h1>نشر البطولة</h1>
  </div>
  <div class="share-container">
    <div class="go_button facebook sm square">
      <i class="icon-facebook" (click)="shareYallaAWC('facebook')">النشر عن طريق فيسبوك</i>
    </div>
    <div class="go_button twitter sm square">
      <i class="icon-twitter" (click)="shareYallaAWC('twitter')">النشر عن طريق تويتر</i>
    </div>
    <div class="go_button whatsapp sm square">
      <i class="icon-whatsapp" (click)="shareYallaAWC('whatsapp')">النشر عن طريق واتس اب</i>
    </div>
  </div>
</div>



<div class="content" style=" direction: rtl; padding:10px 20px;" *ngIf="type=='prizes'">
    <h1 style=" width:100%; text-align:center;">الجوائز</h1>
    <p style="text-align:center;">
        مجموع الجوائز لـ Shawarmer League هي 150,000 ريال سعودي، بيحصل كل فائز بالمركز الأول في تصفيات المدينة الخاصة به للعبة معينة على 2000 ريال سعودي.
    </p>
</div>
